import React from 'react';

const GlobalLoader = ({show, inContainer=false}) => {
    return (
        <>
            {show && (
                <div className={`backdrop${ inContainer ? ' backdrop--container' : '' }`}>
                    <span className="uk-margin-small-right" uk-spinner="ratio: 3"></span>
                </div>
            )}
        </>
    )
}

export default GlobalLoader;
